import { render, staticRenderFns } from "./DecompteTable.vue?vue&type=template&id=48645b0d&scoped=true"
import script from "./DecompteTable.vue?vue&type=script&lang=js"
export * from "./DecompteTable.vue?vue&type=script&lang=js"
import style0 from "./DecompteTable.vue?vue&type=style&index=0&id=48645b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48645b0d",
  null
  
)

export default component.exports